export default __webpack_public_path__ + "./assets/background-pure-tablet__059abc3dce27637f7fd82f49d24aabfd.jpg";